<template>
  <div class="columns my-0">
    <ItemSearch ref="mdlItemSearch" 
      :newItemEnabled="false"
      :title="Model.Report.TitleTransaction"
      @submit="handleSubmit_Item"
    />

    <div class="column is-narrow">
      <kst-input addons floating-label
        field="itemName"
        :data="searchData"
        :catalog="SearchCatalog"
      >
      <template #right>
        <div class="control">
          <template v-if="searchData.DispatchID === null">
            <kst-tooltip search-mode hover-only :content="SearchCatalog.DispatchID.Label">
              <kst-button search-mode @click="handleSearch_Item()"/>
            </kst-tooltip>
          </template>
          <template v-else>
            <kst-tooltip clear-mode hover-only :content="SearchCatalog.DispatchID.Label">
              <kst-button clear-mode @click="handleReset"/>
            </kst-tooltip>
          </template>
        </div>
      </template>
      </kst-input>
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="TransID" :data="searchData" :catalog="SearchCatalog"
        :options="transOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="WarehouseID" :data="searchData" :catalog="SearchCatalog"
        :options="warehouseOptions" @input="handleInput"
      />
    </div>
    <div class="column is-narrow">
      <kst-input floating-label
        field="Date" :data="searchData" :catalog="SearchCatalog"
        @input="handleInput"
      />
    </div>

    <div class="column is-narrow">
      <kst-button reset-mode @click="handleReset"/>
    </div>
  </div>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import SearchCatalog from "../TransactionSearchCatalog.js";
import Model from "../TransactionModel.js";

import ItemSearch from "@/components/Dispatch/Search/DispatchSearch";

export default {
  mixins: [DialogMixin],
  components: {
    ItemSearch
  },
  props: {
    searchData: Object,
    warehouseOptions: Object,
    transOptions: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog,
    Model: Model
  }),
  methods: {
    handleSearch_Item() {
      this.$refs.mdlItemSearch.show();
    },
    handleSubmit_Item(row) {
      this.searchData.itemName = row.FullName;
      this.searchData.DispatchID = row.DispatchID;
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleInput() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>